import {ChangeDetectionStrategy, Component, Inject, OnInit} from '@angular/core';
import {AssetMap, ASSET_MAP} from '@core/constants/client-asset-maps';

@Component({
  selector: 'app-view-coming-soon',
  templateUrl: './view-coming-soon.component.html',
  styleUrls: ['./view-coming-soon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ViewComingSoonComponent {
  constructor(@Inject(ASSET_MAP) readonly assetMap: AssetMap) {}
}
